import { render, staticRenderFns } from "./CustomList.vue?vue&type=template&id=03a95a03&scoped=true"
import script from "./CustomList.vue?vue&type=script&lang=js"
export * from "./CustomList.vue?vue&type=script&lang=js"
import style0 from "./CustomList.vue?vue&type=style&index=0&id=03a95a03&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a95a03",
  null
  
)

export default component.exports